import PropTypes from 'prop-types'
import React from 'react'

import FormSection from '../../shared/components/FormSection'
import AttributedListInput from '../../shared/components/AttributedListInput'
// import TextArea from '../../shared/components/TextArea'

const MaterialFormSection = ({
  materials = [],
  methods = [],
  show,
  validationObj,
  onChange,
  readOnly,
  fieldSpecs
}) => {

  return (
    <FormSection
      title="4. Materialien & Methoden"
      show={show}
    >
      <AttributedListInput
        name="materials"
        placeholder="Anzahl"
        info="(und Anzahl)"
        list={window.APP_CONFIG.list_material}
        value={materials.toJS ? materials.toJS() : materials}
        onChange={onChange}
        isValid={validationObj.materials}
        disabled={readOnly}
        {...fieldSpecs.materials}
      />

      <h3>Methoden</h3>

      <AttributedListInput
        name="methods"
        list={window.APP_CONFIG.list_method}
        value={methods.toJS ? methods.toJS() : methods}
        onChange={onChange}
        isValid={validationObj.methods}
        hideAttribute
        columns={2}
        disabled={readOnly}
        {...fieldSpecs.methods}
      />

    </FormSection>
  )
}

MaterialFormSection.propTypes = {
  show: PropTypes.bool
}

export { MaterialFormSection as default }



// WEBPACK FOOTER //
// ./src/program/components/04-MaterialFormSection.js